import React, { Component } from "react";
import '../../css/Faq/Faq.css';

interface IFaqSectionProps {
    sectionList: any,
    index: number
}

export default class FaqSection extends Component<IFaqSectionProps, {}> {

    public constructor(props: any) {
        super(props);
    }

    public render() {
        let accordionString = "questionAccordion" + this.props.index;

        return (
            <div  className="accordion" id={accordionString}>
                {
                    this.props.sectionList.map((questionList: any, i: number) => {
                        let dataTargetString = "collapseAnswer" + this.props.index + i;
                        let questionHeading = "questionHeading" + this.props.index + i;

                        return(
                            <div key={"QuestionAsked" + (i)} className="card d-flex">
                                <div className="card-header my-auto bg-light" id={questionHeading}>
                                    <h2 className="h-100">
                                        <button className="btn btn-link btn-block text-left font-question h-100" type="button" data-toggle="collapse"
                                                data-target={"#" + dataTargetString} aria-expanded="false" aria-controls={dataTargetString}>
                                            Q: {questionList.question}
                                        </button>
                                    </h2>
                                </div>

                                <div id={dataTargetString} className="collapse" aria-label={questionHeading} data-parent={"#" + accordionString}>
                                    <div className="card-body">
                                        {
                                            questionList.answer.map((ansTxt: string) => {
                                                return <p>{ansTxt}</p>
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        )
    }
}
